<template lang="pug">
.form-controls
  md-input-container(:class='{ "md-input-invalid" : showRequiredError }')
    label(for='genre') Categories
    md-select#genre(name='genre', :multiple='multiple', v-model='selected', @selected='onGenreSelected')
      md-option(v-for='genre in genres', :value='genre.name', :key='genre.name') {{ genre.name }}
    span.md-error(v-if='showRequiredError') This field is required
</template>

<script>
  import genreService from '../../services/genreService';

  export default {
    props: {
      value: {
        type: [String, Array],
        required: true
      },
      multiple: {
        type: Boolean,
        default: false
      },
      showRequiredError: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selected: this.value,
        genres: [...genreService.getTopLevelGenres(),...this.customCategories()]
          .filter(
            (item) => item.name !== 'News and Politics' && item.name !== 'Music and Audio')
          .sort(
            (a,b) => ( a.name > b.name ) - ( a.name < b.name ) )
      };
    },
    methods: {
      onGenreSelected(value) {
        this.$emit('input', value);
      },
      customCategories(){
        return [
          {name:'Workout'},
          {name:'Yoga, Pilates, Stretching'},
          {name:'Cardio'},
          {name:'Strength Training'},
          {name:'Quarantine'},
          {name:'Design'},
          {name:'Culture'},
          {name:'Architecture'},
          {name:'Lifestyle'},
          {name:'Good Causes'},
          {name:'Classic TV'},
          {name:'Classic Crime Fighters'},
          {name:'Classic Comedy'},
          {name:'Classic Movies'},
          {name:'News'},
          {name:'Politics'},
          {name:'Music'},
          {name:'Podcasts and Audio'},
          {name: 'Documentary'},
          {name: 'Western'},
          {name: 'Animation and Cartoons'},
          {name: 'PSA'},
          {name: 'Film Festival'},
        ]
      }
    },
    watch: {
      value(newValue) {
        if (newValue) {
          this.selected = newValue;
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .form-controls {
    width: 100%;
  }
</style>




// WEBPACK FOOTER //
// src/shared-components/genre/GenreSelector.vue